import { observer } from 'mobx-react-lite';
import { useFormContext, useWatch } from 'react-hook-form';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { FormBody } from '../../../forms/integrated-form-components/form-body';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { EventPanelFormType } from '@mark43/cad-api';
import { useAllowAddingTowVehicles } from '../../use-allow-adding-tow-vehicles';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { TabSubtitle } from '../../../panels/entity-panels/tabs/tab-subtitle';
import { Box } from '@cad-arc';
import { EventPanelFormVehiclesFields } from '../../event-panel-form/involved-person-vehicle-fields/vehicles/event-panel-form-vehicles-fields';

export const VehiclesTab = observer(function VehiclesTab() {
    const eventForm = useFormContext<EventPanelFormType>();
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const { eventsAllowAddingTowVehicle } = useEnabledFeatures();
    const { hasMergedEvents } = useEventMetadataStore().state.metadata ?? {};
    const allowAddingTowVehicles = useAllowAddingTowVehicles();
    const vehicles = useWatch({
        control: eventForm.control,
        name: 'vehicles',
    });
    const towVehicles = useWatch({
        control: eventForm.control,
        name: 'towVehicles',
    });
    const mergedVehicles = useWatch({
        control: eventForm.control,
        name: 'mergedVehicles',
    });
    const mergedTowVehicles = useWatch({
        control: eventForm.control,
        name: 'mergedTowVehicles',
    });

    return (
        <EventPanelTab title="Vehicles">
            <TabBody>
                <TabSubtitle>Vehicles ({vehicles.length})</TabSubtitle>
                <FormBody>
                    <>
                        <EventPanelFormVehiclesFields
                            displayAsCards
                            form={eventForm}
                            eventPanelOptions={eventPanelOptions!}
                            hideDexFields={true}
                            allowMembersControl={true}
                            baseKey="vehicles"
                            addButtonText="Add Vehicle"
                            noMembersText="No Vehicles"
                        />
                        {eventsAllowAddingTowVehicle && (
                            <Box pt={4}>
                                <TabSubtitle>Tow Vehicles ({towVehicles.length})</TabSubtitle>
                                <EventPanelFormVehiclesFields
                                    displayAsCards
                                    form={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                    asTowVehicle={true}
                                    allowMembersControl={allowAddingTowVehicles}
                                    baseKey="towVehicles"
                                    addButtonText="Add Tow Vehicle"
                                    noMembersText="No Tow Vehicles"
                                />
                            </Box>
                        )}
                        {hasMergedEvents && (
                            <Box pt={4}>
                                <TabSubtitle>Merged Vehicles ({mergedVehicles.length})</TabSubtitle>
                                <EventPanelFormVehiclesFields
                                    displayAsCards
                                    form={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                    allowMembersControl={false}
                                    baseKey="mergedVehicles"
                                    noMembersText="No Merged Vehicles"
                                />
                            </Box>
                        )}

                        {hasMergedEvents && eventsAllowAddingTowVehicle && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Merged Tow Vehicles ({mergedTowVehicles.length})
                                </TabSubtitle>
                                <EventPanelFormVehiclesFields
                                    displayAsCards
                                    form={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                    asTowVehicle={true}
                                    baseKey="mergedTowVehicles"
                                    addButtonText="Add Tow Vehicle"
                                    noMembersText="No Merged Tow Vehicles"
                                />
                            </Box>
                        )}
                    </>
                </FormBody>
            </TabBody>
        </EventPanelTab>
    );
});
